export default {
    props: {
        idPanel: {
            type: String,
            default: null
        },
        title: {
            type: [String, null, undefined],
            default: null
        },
        translateID: {
            type: String,
            default: 'broadcasting'
        },
        allowReconnect: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {

        }
    },
    mounted() {
        this.$nextTick(function () {
            this.$root.$helper.global.activeTooltip('window');
        });
    },
    computed: {
        titlePanel() {
            return (this.title == null || this.title == undefined) && this.idPanel ? this.$t(`${this.translateID}.states.${this.idPanel}.title`) : this.title;
        }
    },
    methods: {
        onClick() {
            if(this.allowReconnect) {
                this.$root.$emit('openConfirmation', {
                    id: null,
                    data: {},
                    text: this.$t(`${this.idPanel}.states.disconnected.msg.reconnect_confirm`),
                    callback: (id, data) => {
                        this.$emit('click')
                    }
                });
            }else{
                this.$emit('click')
            }
        },
        reconnect() {

        }
    },
};